/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Alert } from 'reactstrap';

const ModalContratante = ({ label = '', catalogo = {} }) => {
  const [showModal, setShowModal] = useState(false);
  const [valor, setValor] = useState('');
  const [tipo, setTipo] = useState('text');

  useEffect(() => {
    console.log('Catalogo', catalogo);
    if (
      (catalogo?.DatosContratanteAsegurado?.requiereFactura === 'SI' ||
        catalogo?.DatosContratanteAsegurado?.tipoPersona?.value === 'J' ||
        catalogo?.DatosContratanteAsegurado?.tipoPersona?.value === 'M') &&
      catalogo?.textosAyuda?.mensajeContratanteCFDIObj
    ) {      
      if (catalogo?.textosAyuda?.mensajeContratanteCFDIObj?.type !== 'text') {
        setTipo(catalogo?.textosAyuda?.mensajeContratanteCFDIObj?.type);
      }      
      setValor(catalogo?.textosAyuda?.mensajeContratanteCFDIObj?.value);
      setShowModal(true);
    }
  }, []);

  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <h2 className="text-mex">{label}</h2>
        </Modal.Header>
        <Modal.Body>
          {tipo ==='text' && (
              <Alert color="info" isOpen={true} toggle={false}>
              <p style={{ fontSize: '20px', textAlign: 'justify' }}>{valor}</p>
            </Alert>
          )}
          {tipo ==='img' && (
              <img src={valor} style={{width:"100%"}} />  
          )}
          
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalContratante;
